import type { Currency } from '../dataProvider/types';

/** Currency symbol per settlement currency: £ gbp, $ usd, € eur. */
const SYMBOL_BY_CURRENCY: Record<Currency, string> = {
  gbp: '£',
  usd: '$',
  eur: '€',
};

// Grouped, 2-dp number formatting (deterministic en-US grouping; the symbol is
// chosen by currency separately so the glyph never depends on ICU locale data).
const groupedAmount = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/**
 * Format a money amount in the row's currency (e.g. 42.5, 'gbp' -> "£42.50";
 * 1200, 'usd' -> "$1,200.00"). A non-numeric amount renders as an em dash.
 */
export const formatMoney = (amount: unknown, currency: unknown): string => {
  const n = Number(amount);
  if (amount === null || amount === '' || !Number.isFinite(n)) return '—';
  const symbol = SYMBOL_BY_CURRENCY[currency as Currency] ?? '';
  return `${symbol}${groupedAmount.format(n)}`;
};
